import { ApiDimension, ApiOperator } from "@incendium/api";

const PAID_CHANNEL_ATTRIBUTES = [
  {
    key: ApiDimension.DIMENSION_TRAFFIC_TYPE,
    operator: ApiOperator.EQUAL,
    value: "Paid",
  },
];

const withPaidChannelAttributes = (Comp: React.ComponentType<any>) => {
  return (props) => {
    return <Comp {...props} paidChannelAttributes={PAID_CHANNEL_ATTRIBUTES} />;
  };
};

export default withPaidChannelAttributes;
